const messages = {
  en: {
    "monthly-plan": "Monthly plan",
    "monthly-price": "$9.99",
    "monthly-period": "per month",
    "annual-plan": "Annual plan",
    "annual-price": "$99.00",
    "annual-period": "per year",
    "annual-save": "Save up to 20%<sup>2</sup>",
  },
  fr: {
    "monthly-plan": "Plan mensuel",
    "monthly-price": "9,99 $",
    "monthly-period": "par mois",
    "annual-plan": "Plan annuel",
    "annual-price": "99,00 $",
    "annual-period": "par an",
    "annual-save": "Économisez jusqu'à 20 %<sup>2</sup>",
  },
};

export default messages;
